var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49993 2H13.4999L8.48993 8.3L3.49993 2ZM0.749934 1.61C2.76993 4.2 6.49993 9 6.49993 9V15C6.49993 15.55 6.94993 16 7.49993 16H9.49993C10.0499 16 10.4999 15.55 10.4999 15V9C10.4999 9 14.2199 4.2 16.2399 1.61C16.7499 0.95 16.2799 0 15.4499 0H1.53993C0.709934 0 0.239934 0.95 0.749934 1.61Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.60c0522cc95d60911aa40beff9772f93.svg";
export { ForwardRef as ReactComponent };